import { isMobile } from "components/utility/page-responsive/PageResponsive";

const individualSiteObserver = new IntersectionObserver(
	(entries) => {
		entries.forEach((entry) => {
			if (entry.target.classList.contains("animated-markets")) {
				if (entry.isIntersecting && !isMobile()) {
					entry.target.classList.add("animate");
				}
			}
			if (entry.target.classList.contains("animated-fast-facts-section")) {
				if (entry.isIntersecting && !isMobile()) {
					entry.target.classList.add("facts-show");
					const facts = entry.target.querySelectorAll(".animated-fast-facts-fact");
					const factsText = entry.target.querySelectorAll(".animated-fast-facts-fact-text");
					facts.forEach((fact, i) => fact.classList.add(`ff-animate-${i + 1}`, `fact-${i + 1}`));
					factsText.forEach((factText, i) => factText.classList.add(`ff-animate-${i + 1}`));
				}
			}
		});
	},
	{
		root: null,
		rootMargin: "0px 0px -25% 0px",
		threshold: 0
	}
);

export const observeIndividualSiteAnimations = () => {
	const individualElements = document.querySelectorAll(".individual-animations");
	if (individualElements) {
		individualElements.forEach((element) => individualSiteObserver.observe(element));
	}
};

export const disconnectIndividualSiteObserver = () => {
	individualSiteObserver.disconnect();
};
